<div class="goldStandardSection">
  <div class="goldStandardCopyWrapper">
    <div class="goldStandardCopy">
<h2>The <span class="cscGoldText">Gold Standard</span>.</h2>
<p>With over 60,000 active and trained team members nationally, CSC currently provides crowd management services for over 110 universities and scholastic institutions, 200 stadiums, arenas and theaters, 50 convention centers, 9 NFL teams, 6 MLB teams, 4 NBA teams, 5 MLS clubs and 4 NHL teams.
</p>
  <p>
    CSC has delivered services for every type of entertainment and sporting event, including 33 Super Bowls, 8 World Series, 4 MLB All-Star Games, 9 NCAA Men’s Final Four, 5 annual College Bowl Games, 7 NBA Finals, 10 Olympic Games, 5 Presidential Inaugurations, 4 Papal Visits, and 2 FIFA World Cups.
  </p>
    </div>
  </div>
</div>
 <!-- "template-accessibility-alt-text": true,
 "template-accessibility-elements-content": true,
 "template-accessibility-label-for": true,
 "template-accessibility-tabindex-no-positive": true,
 "template-accessibility-table-scope": true,
 "template-accessibility-valid-aria": true,
 "template-click-events-have-key-events": true,
 "template-mouse-events-have-key-events": true,
 "template-no-autofocus": true,
 "template-no-distracting-elements": true, -->
